import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

document.querySelectorAll('.product_categories_slider')?.forEach((element) => {
    const paginationEl = element.parentElement.querySelector(
        '.highlighted_categories-pagination-container',
    );
    const nextEl = element.parentElement.querySelector('.highlighted_categories-navigation-right');
    const prevEl = element.parentElement.querySelector('.highlighted_categories-navigation-left');

    return new Swiper(element, {
        modules: [Navigation, Pagination],
        slidesPerView: 'auto',
        spaceBetween: 8,
        breakpoints: {
            768: {
                spaceBetween: 16,
            },
        },
        pagination: {
            el: paginationEl,
            clickable: true,
            renderBullet: (index, className) => {
                return `<span class="${className}"></span>`;
            },
        },
        navigation: {
            nextEl,
            prevEl,
        },
    });
});
